import { CreditReport as CanadaCreditReportPb } from "@repo/protobuf/gen/kikoff_canada/protobuf/models/credit/credit_report_pb";
import { Address } from "@repo/protobuf/gen/kikoff_canada/protobuf/types/pii/address_pb";
import Protobuf from "@repo/protobuf/utils";
import FullName from "@repo/utils/FullName";

import { FullNameCanada } from "../FullName.js";

import ReportAccount, { ReportAccountCanada } from "./ReportAccount.js";

type CreditReport = {
  id: CreditReport.Id;
  generatedAt: Date;
  accounts: ReportAccount[];
  name: FullName;
  dateOfBirth: string;
  address: Address;
  previousAddresses: Address[];
};

namespace CreditReport {
  export type Id = string & {};
}

export default CreditReport;

export namespace CreditReportCanada {
  export function normalize(proto: CanadaCreditReportPb): CreditReport {
    return {
      id: proto.id,
      generatedAt: Protobuf.Timestamp.toDate(proto.generatedAt!),
      accounts: proto.accounts.map(ReportAccountCanada.normalize),
      name: FullNameCanada.normalize(proto.name!),
      dateOfBirth: proto.dateOfBirth,
      address: proto.address!,
      previousAddresses: proto.previousAddresses,
    };
  }
}
